import { UserRoles } from '../store/models/User';

export const isRoleAllowed = (roles: UserRoles[], currentRoles: UserRoles[] | null) => {
  if (!currentRoles) {
    return null;
  }

  return currentRoles?.some((currentRole) => roles.includes(currentRole));
};
